import {makeAutoObservable} from 'mobx';
import witConfigService, {defaultWitConfig} from "../services/witConfigService";
import witIntentApiService from "../services/witIntentApiService";

export class WitConfigState {
  rootStore;
  config = defaultWitConfig;
  dataLoaded = false;
  availableIntents = [];
  intentsLoaded = false;
  availableEntities = [];
  entitiesLoaded = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  setConfig(config) {
    this.config = {
      ...defaultWitConfig,
      ...(config || {}),
      thresholds: {
        ...defaultWitConfig.thresholds,
        ...(config?.thresholds || {}),
      },
      intents: Array.isArray(config?.intents) ? config.intents : defaultWitConfig.intents,
      entities: Array.isArray(config?.entities) ? config.entities : defaultWitConfig.entities,
    };
  }

  setAvailableIntents(intents) {
    this.availableIntents = Array.isArray(intents) ? intents.filter(Boolean) : [];
    this.intentsLoaded = true;
  }

  setAvailableEntities(entities) {
    this.availableEntities = Array.isArray(entities) ? entities.filter(Boolean) : [];
    this.entitiesLoaded = true;
  }

  setEnabled(value) {
    this.config.enabled = value;
  }

  setThreshold(actionKey, value) {
    this.config.thresholds[actionKey] = Number(value);
  }

  setIntentsFromText(text) {
    this.config.intents = text
      .split(/\r?\n/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  setEntitiesFromText(text) {
    this.config.entities = text
      .split(/\r?\n/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  toggleIntentSelection(intent, selected) {
    const current = Array.isArray(this.config.intents) ? this.config.intents : [];
    if (selected) {
      this.config.intents = [...new Set([...current, intent])].sort();
      return;
    }
    this.config.intents = current.filter((item) => item !== intent);
  }

  toggleEntitySelection(entity, selected) {
    const current = Array.isArray(this.config.entities) ? this.config.entities : [];
    if (selected) {
      this.config.entities = [...new Set([...current, entity])].sort();
      return;
    }
    this.config.entities = current.filter((item) => item !== entity);
  }

  loadWitConfig() {
    return witConfigService.loadWitConfig()
      .then((config) => {
        this.setConfig(config);
        this.dataLoaded = true;
      })
      .catch((reason) => {
        this.dataLoaded = true;
        console.error(reason);
      });
  }

  loadAvailableIntents() {
    const authToken = this.rootStore?.authState?.serverToken;
    if (!authToken) {
      return Promise.resolve([]);
    }
    return witIntentApiService.loadIntents(authToken)
      .then((intents) => {
        this.setAvailableIntents(intents);
        return intents;
      })
      .catch((reason) => {
        this.intentsLoaded = true;
        console.error(reason);
        return [];
      });
  }

  loadAvailableEntities() {
    const authToken = this.rootStore?.authState?.serverToken;
    if (!authToken) {
      return Promise.resolve([]);
    }
    return witIntentApiService.loadEntities(authToken)
      .then((entities) => {
        this.setAvailableEntities(entities);
        return entities;
      })
      .catch((reason) => {
        this.entitiesLoaded = true;
        console.error(reason);
        return [];
      });
  }

  saveWitConfig() {
    return witConfigService.saveWitConfig(this.rootStore.authState.user?.uid, this.config)
      .then((config) => {
        this.setConfig(config);
      })
      .catch(console.error);
  }
}
